import { OrgTransaction, PublicTransaction } from '~/types'

// Members of several orgs and Splits admins get the full org shape for
// transactions outside their active org, so `isPublicTransaction` alone isn't
// enough.
export const isActiveOrgTransaction = ({
  transaction,
  activeOrgId,
}: {
  transaction: OrgTransaction | PublicTransaction
  activeOrgId?: string
}): boolean =>
  !transaction.isPublicTransaction &&
  !!activeOrgId &&
  transaction.orgId === activeOrgId
